import React, { useEffect } from "react";

import HeroSlider from "../components/HeroSlider";
import MovieArea from "../components/MovieArea";
import EventOffer from "../components/EventOffer";
import { useNavigate, useSearchParams } from "react-router-dom";

const HomePage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const code = searchParams.get("b");

    if (code) {
      // redirect to your existing route
      navigate(`/b/${code}`, { replace: true });
    }
  }, []);
  return (
    <>
      {/* Hero Slider */}
      <HeroSlider />

      {/* Banner Section */}

      <div className="homepage-banner">
        <img src="/assets/img/Banner_updated.png" alt="Homepage Banner" />
      </div>

      {/* Movie Area */}
      <MovieArea />

      {/* Offers Section */}
      <EventOffer />

      {/* Instagram Feed */}
      <div className="container">
        <div
          className="elfsight-app-9807590a-7791-4efc-b004-385361d3451b"
          data-elfsight-app-lazy
        ></div>
      </div>
    </>
  );
};

export default HomePage;
